module.exports = __webpack_public_path__ + "img/295.cacc4e09.jpg";